import _ from 'lodash';

export function isSameArrays<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return _.difference(arr1, arr2).length === 0;
}
